import type { UserRole, UserDto } from '~/services/api/generated'

/** Single source of role names for a `UserDto`: its `roles` list. */
export function resolveRoleNames(user: UserDto | null): UserRole[] {
  return user === null ? [] : user.roles
}
